<template>
  <div class="mb-1 xl:mb-2">
    <!-- LABEL -->
    <div class="flex flex-row justify-between align-middle mb-[0.15rem] lg:mb-1">
      <label :for="fieldId" class="block text-grey-300 text-xs lg:text-sm">
        {{ label }}
        <span v-if="required" class="text-red-500 ml-1 lg:ml-2">*</span>
      </label>
    </div>

    <!-- COMBOBOX -->
    <div class="relative text-xs lg:text-sm">

      <!-- LOADING -->
      <div v-if="isLoading"
        class="border xl:border-2 rounded-[0.35rem] lg:rounded-[0.5rem] w-full h-[36px] lg:h-[46px] flex items-center justify-center border-gray-400 bg-gray-100">
        <span class="loader"></span>
      </div>

      <!-- NORMAL -->
      <template v-else>
        <div
          class="border xl:border-2 rounded-[0.35rem] lg:rounded-[0.5rem] w-full flex items-center justify-between"
          :class="[
            disabled
              ? 'bg-gray-100 cursor-not-allowed opacity-70 border-gray-300'
              : 'cursor-pointer border-gray-300'
          ]" @click="toggleDropdown">
          <!-- DISPLAY VALUE -->
          <span class="p-2 lg:p-3 w-full truncate" :class="{ 'text-gray-400': !selectedLabel }">
            {{ selectedLabel || placeholder }}
          </span>

          <!-- DROPDOWN ICON -->
          <span class="pr-2 lg:pr-3">
            <img src="@/assets/images/papsi_down.svg" class="w-4 h-4 lg:w-6 lg:h-6">
          </span>
        </div>

        <!-- DROPDOWN -->
        <div v-if="isOpen"
          class="absolute left-0 w-full bg-white border z-10 rounded-[0.35rem] lg:rounded-[0.5rem] shadow-lg max-h-[30vh] overflow-y-auto">
          <div v-for="option in options" :key="option.value" @click.stop="selectOption(option)"
            class="px-2 py-1 lg:px-4 lg:py-3 hover:bg-gray-100 cursor-pointer">
            {{ option.label }}
          </div>
        </div>
      </template>

    </div>

    <!-- VALIDATION -->
    <p v-if="validationMessage" class="md:text-2xl xl:text-4xl text-red md:mt-3 xl:mt-5">
      {{ validationMessage }}
    </p>
  </div>
</template>

<script>

export default {
  name: "v-combobox",
  props: {
    label: String,
    fieldId: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "Select an option",
    },
    options: {
      type: Array,
      required: true,
      // [{ label: "Option 1", value: "1" }]
    },
    modelValue: [String, Number],
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.modelValue || "",
      validationMessage: "",
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.options.find(
        (opt) => opt.value === this.selectedValue
      );
      return selected ? selected.label : "";
    },
  },
  watch: {
    modelValue(newVal) {
      this.selectedValue = newVal;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    toggleDropdown() {
      if (this.disabled || this.isLoading) return;

      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      if (this.disabled || this.isLoading) return;

      this.selectedValue = option.value;
      this.isOpen = false;

      this.validateField();
      this.$emit("update:modelValue", this.selectedValue);
    },
    handleOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
    validateField() {
      let isValid = true;
      this.validationMessage = "";

      if (this.required && !this.selectedValue) {
        this.validationMessage = "This field is required.";
        isValid = false;
      }

      this.$emit("validation-status", this.fieldId, isValid);
    },
  },
};
</script>

<style scoped>
.loader {
  width: 24px;
  height: 24px;
  border: 3px solid #8a8a8a;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@media (max-width: 1000px) {
  .loader {
    width: 16px;
    height: 16px;
    border: 3px solid #8a8a8a;
    border-bottom-color: transparent;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>